import { useState } from 'react';
import { resetDomainData, setDomainData, useDomainData } from '../context/domainAtoms';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { SITE_PREVIEW_URL } from '../../../consts';

export const useDomainLogic = () => {
  const { navigate } = useAppNavigation();
  const { availableDomain } = useDomainData();

  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedSuggestion, setSelectedSuggestion] = useState<string>(availableDomain);

  const onSearchChange = (value: string) => {
    setSelectedSuggestion('');
    setSearchValue(value);
  };

  const onSuggestionSelect = (value: string) => {
    setSelectedSuggestion(value);
    setDomainData({
      availableDomain: value,
    });
  };

  const onContinue = ({ skip }: { skip?: boolean }) => {
    if (skip) {
      resetDomainData();
    }
    navigate(SITE_PREVIEW_URL);
  };

  return {
    onContinue,
    search: {
      value: searchValue,
      onChange: onSearchChange,
    },
    selectedSuggestion: {
      value: selectedSuggestion,
      onSelect: onSuggestionSelect,
    },
  };
};
